import { P, convertArrayObjectKeysCase, convertObjectKeysCase, match } from '@frontend/duck-tape';

export const camelCaseApiResponse = <T extends GenericRecord | GenericRecord[]>(response: unknown): T => {
  return match(response)
    .with(P.array(), (arr) => convertArrayObjectKeysCase(arr, 'camelCase') as T)
    .with(P.instanceOf(Object), (obj) => convertObjectKeysCase(obj, 'camelCase') as T)
    .otherwise((value) => {
      // eslint-disable-next-line no-console
      console.error('Unhandled case when transforming API response', value);
      return value as T;
    });
};
